import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { CandidateResultData } from "pages/Vacancies/view/types";

interface CandidatesTableProps {
  data: CandidateResultData;
}

const CandidatesTable = ({ data }: CandidatesTableProps) => {
  const rows = data.map((item) => Object.values(item));
  const headCells = Object.keys(data[0]);

  return (
    <TableContainer sx={{ marginTop: 2, maxHeight: 215, paddingRight: 1.5 }}>
      <Table size='small'>
        <TableHead>
          <TableRow>
            {headCells.map((headCell, headCellIndex) => (
              <TableCell
                /* eslint-disable-next-line react/no-array-index-key */
                key={headCellIndex}
                sx={{
                  whiteSpace: "nowrap",
                  backgroundColor: "bgSwitch",
                  "& .MuiTableSortLabel-root.Mui-active": { color: "primary.main" },
                }}>
                {headCell}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow
              hover
              /* eslint-disable-next-line react/no-array-index-key */
              key={rowIndex}>
              {row.map((cell, cellIndex) => (
                /* eslint-disable-next-line react/no-array-index-key */
                <TableCell key={cellIndex}>{cell}</TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CandidatesTable;
